import React, {useEffect, useState} from 'react'
import {Rect} from "react-konva";
import useImage from "use-image";
import {BLOCK_SNAP_SIZE} from "../../../design/constants/design.constant";

const ProductImageRectangle = ({
                                   productImage,
                                   onChange,
                               }) => {
    const [image] = useImage(productImage.url, 'anonymous');
    const shapeRef = React.useRef();

    const handleDragEnd = (event) => {
        const node = shapeRef.current || undefined;

        const currentNodeRef = event.target;
        currentNodeRef.position({
            x: Math.round(currentNodeRef.x() / BLOCK_SNAP_SIZE) * BLOCK_SNAP_SIZE,
            y: Math.round(currentNodeRef.y() / BLOCK_SNAP_SIZE) * BLOCK_SNAP_SIZE
        });

        onChange({
            ...productImage?.props,
            x: node.x(),
            y: node.y(),
            scaleX: node.scaleX(),
            scaleY: node.scaleY(),
            totalWidth: node.width(),
            totalHeight: node.height()
        });
    }

    return (
        <>
            {image &&
                <Rect
                    name={'product-image-rectangle'}
                    ref={shapeRef}
                    fillPatternImage={image}
                    fillPatternRepeat={'no-repeat'}
                    {...productImage?.props}
                    draggable
                    onDragMove={(e) => {
                        handleDragEnd(e);
                    }}
                    onDragEnd={(e) => {
                        handleDragEnd(e);
                    }}
                />
            }
        </>
    )
}

export default ProductImageRectangle
